import { /* MutableRefObject, */ memo } from 'react'
// import PmChat, { type Chat as PmChatClass } from '../PMs/Chat'
import { PMChat } from '../PM/PMChat/PMChat'
import RoomChat from './RoomChat'

export type ChatProps = {
    id: number
    pm: boolean
    showLoungePreviews?: boolean
    pinned?: boolean
    showingTips?: boolean
    height?: number
    styleHeight?: number | string
    chatRef?: any //MutableRefObject<PmChatClass>
    isQuickReply?: boolean
    noNews?: boolean
    styleDisplay?: string

    onOpenWhiteboard?(identifier: string | number): void
    setLoungePreviews?(cb?: (prev: boolean) => boolean): void
    onTipToggle?(): void
}

const Chat = memo((props: ChatProps) => {
    const { pm, ...chatProps } = props
    return pm ? <PMChat {...chatProps} /> : <RoomChat {...chatProps} />
})

export default Chat
